import { useState } from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset Password" subtitle="We'll email you a secure reset link" testid="forgot-password-page">
      {sent ? (
        <div className="text-center py-6" data-testid="forgot-sent">
          <div className="w-14 h-14 rounded-full bg-accent/15 flex items-center justify-center mx-auto"><EnvelopeSimple size={28} weight="duotone" className="text-accent" /></div>
          <h3 className="font-display text-xl mt-4 text-primary">Check your inbox</h3>
          <p className="text-sm text-muted-foreground mt-1">If <span className="font-medium text-primary">{email}</span> is registered, we've emailed a link to reset your password. It expires in 1 hour.</p>
          <Link to="/login"><Button variant="outline" className="mt-6 rounded-full">Back to Login</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-request-form">
          <div className="space-y-1.5"><Label>Registered Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-email" /></div>
          {error && <div className="text-sm text-destructive" data-testid="forgot-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-primary hover:bg-[#113A64]" data-testid="forgot-submit">{loading ? "Sending…" : "Email Reset Link"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
